export const MOCK_PLAN_A_ID = 'MOCK_PLAN_A_ID'
export const MOCK_PLAN_B_ID = 'MOCK_PLAN_B_ID'
